/**
 * @generated SignedSource<<0da6d0b0af8f3c1286e6b0f273c13f78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetCalendarOverviewSettingsQuery$variables = Record<PropertyKey, never>;
export type WidgetCalendarOverviewSettingsQuery$data = {
  readonly store: {
    readonly calendars: ReadonlyArray<{
      readonly color: string;
      readonly id: string;
      readonly title: string;
    }>;
  };
};
export type WidgetCalendarOverviewSettingsQuery = {
  response: WidgetCalendarOverviewSettingsQuery$data;
  variables: WidgetCalendarOverviewSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreCalendar",
  "kind": "LinkedField",
  "name": "calendars",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetCalendarOverviewSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WidgetCalendarOverviewSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "76c18f665fa16b032d0936053326c2dc",
    "id": null,
    "metadata": {},
    "name": "WidgetCalendarOverviewSettingsQuery",
    "operationKind": "query",
    "text": "query WidgetCalendarOverviewSettingsQuery {\n  store {\n    calendars {\n      id\n      title\n      color\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4bcc8d02d1d8b45f9958cf7fdcfac6a6";

export default node;
